/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";

const employeeGroupBaseKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.employee_groups)
);

export const employeeGroupMutationKeyGroups = {
  create: employeeGroupBaseKeys,
  update: employeeGroupBaseKeys,
  delete: employeeGroupBaseKeys,
};
